import wx from "weixin-js-sdk";
const WXObj = {
  WXSetting: function (data) {
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: data.appid, // 必填，公众号的唯一标识
      timestamp: data.timestamp, // 必填，生成签名的时间戳
      nonceStr: data.noncestr, // 必填，生成签名的随机串
      signature: data.signature, // 必填，签名，见附录1
      jsApiList: [
        "checkJsApi",
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "onMenuShareQQ",
        "onMenuShareWeibo",
        "onMenuShareQZone",
        "hideMenuItems",
        "showMenuItems",
        "hideAllNonBaseMenuItem",
        "showAllNonBaseMenuItem",
        "translateVoice",
        "startRecord",
        "stopRecord",
        "onVoiceRecordEnd",
        "playVoice",
        "onVoicePlayEnd",
        "pauseVoice",
        "stopVoice",
        "uploadVoice",
        "downloadVoice",
        "chooseImage",
        "previewImage",
        "uploadImage",
        "downloadImage",
        "getNetworkType",
        "openLocation",
        "getLocation",
        "hideOptionMenu",
        "showOptionMenu",
        "closeWindow",
        "scanQRCode",
        "chooseWXPay",
        "openProductSpecificView",
        "addCard",
        "chooseCard",
        "openCard"
      ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });
    wx.ready(function () {
      wx.checkJsApi({
        jsApiList: [
          'getLocation'
        ],
        success: function (res) {
          if (res.checkResult.getLocation == false) {
            alert('你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！');
            return;
          }
        }
      });
      wx.hideMenuItems({
        menuList: [
          "menuItem:copyUrl",
          "menuItem:openWithQQBrowse",
          "menuItem:openWithSafari",
          "menuItem:email",
          "menuItem:readMode",
          "menuItem:originPage",
          "menuItem:delete",
          "menuItem:editTag"
        ]
      });

      //layer.closeAll(layer.index);
    });
  },
  getLocation: function (callback) {
    wx.getLocation({
      success: function (res) {
        callback(true, res);
      },
      cancel: function (res) {
        callback(false, res);
      }
    });
  },
  previewImage:function (curUrl,Urls) {
    wx.previewImage({
      current:curUrl, // 当前显示图片的http链接
      urls: Urls // 需要预览的图片http链接列表
    });
  },
  chooseImage: function (callback) {
    wx.chooseImage({
      count: 1, // 默认9
      sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
      sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      success: function (res) {
        var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
        callback(res);
      }
    });
  },
  
  getLocalImgData: function (localId, callback) {
    wx.getLocalImgData({
      localId: localId, // 图片的localID
      success: function (res) {
        console.log('getLocalImgData');
        console.log(res);
        callback(res.localData); // localData是图片的base64数据，可以用img标签显示
      }
    });
  },
  openScanVidio: function (callback) {
    //callback("123456789012345678901234");
    wx.scanQRCode({
      desc: "scanQRCode desc",
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
      success: function (res) {
        var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
        var param = result;
        if (result.indexOf("http") == -1) {
          var resultSplit = result.split(",");
          param = resultSplit[resultSplit.length - 1];
        }
        callback(param);
      }
    });
  }
};
export { WXObj }